import { Option } from "@/common/types/option";
import { Mission } from "../types/mission.type";
import { MissionProvider } from "../types/missionProvider.type";
import { Product } from "../hooks/useMissionProducts";
import { MissionCompanyBranchOption } from "../hooks/useMissionCompanyBranches";

export class MissionFormOptionsTransformer {
  static providerOptions(providers: MissionProvider[]): Option[] {
    return providers.map((provider) => ({
      label:
        provider.display_name ||
        provider.provider_klass?.split("::").pop() ||
        provider.provider_klass,
      value: provider.provider_klass,
    }));
  }

  static productOptionsFromApi(products: Product[]): Option[] {
    return products.map((product) => ({
      label: product.display_name || `Produto ${product.id}`,
      value: String(product.id),
    }));
  }

  static initialProductOptions(mission?: Mission): Option[] {
    if (!mission?.rewards) return [];
    const map = new Map<string, Option>();

    mission.rewards.forEach((reward) => {
      if (reward.reward_type !== "product") return;
      const productId = reward.product_id || reward.reward_id;
      if (!productId) return;
      const label =
        reward.product_name || reward.reward_label || `Produto ${productId}`;
      map.set(String(productId), {
        label: String(label),
        value: String(productId),
      });
    });

    return Array.from(map.values());
  }

  static mergeOptions(primary: Option[], secondary: Option[]): Option[] {
    const map = new Map<string, Option>();
    primary.forEach((option) => {
      map.set(String(option.value), option);
    });
    secondary.forEach((option) => {
      map.set(String(option.value), option);
    });
    return Array.from(map.values());
  }

  static initialEstablishmentOptions(mission?: Mission): Option[] {
    if (!mission?.establishment) return [];
    return [
      {
        label: mission.establishment.display_name,
        value: mission.establishment.id,
      },
    ];
  }

  static establishmentOptionsFromBranches(
    branches: MissionCompanyBranchOption[],
  ): Option[] {
    return branches.map((branch) => ({
      label: branch.display_name,
      value: branch.id,
    }));
  }
}
